import React from 'react';
import { RoundedButtonWithText } from '../RoundedButtonWithText';

export const GrantConsentButton = ({ onClick, disabled }) => (
  <RoundedButtonWithText
    variant="contained" 
    color="primary" 
    onClick={onClick}
    disabled={disabled}
  >I Consent*</RoundedButtonWithText>
);